export const STORAGE_KEY = {
  AUTH_TOKEN: 'tkn',
  AUTH_UUID: 'authUuid',
  EMAIL: 'em',
  CACHED_CALENDAR_DATA: 'cad',
  AVAILABLE_SLOT_VIEW_MODE: 'view-mode',
  LAST_SELECTED_COUNTRY_CODE: 'last-selected-country-code',
  LAST_SELECTED_DURATION: 'last-selected-duration',
  COOKIES_CONFIG: 'cc',
  GOOGLE_PLACE: 'pi',
  LANGUAGE: 'language',
  REFERRER: 'ref',
  RESEND_PIN_TIMESTAMP: 'rpt',
  RWG_DATA: 'rwgd',
  SAVED_CREDIT_ORDER_DATA: 'scod', // TODO: deprecated. Should be removed
  SELECTED_BO_ID: 'boid',
  TOP_SALONS_SELECTED_COUNTRY: 'tsc',
  UNFINISHED_BOOKING_DATA: 'ubd',
};
